export const BUSINESS_API_URL = {
  CREATE_BUSINESS: 'business',
  BUSINESS_SETTING: 'business/settings',
  SELECT_BUSINESS: 'business/add-user-to-business',
  BUSINESS_BY_USER_ID: 'business/business-by-user-id',
  CHANGE_BUSINESS: 'business/change-business',
};
